<div class="tdo-dropdown-menu" matTooltip="{{tooltip}}" data-cy="tdo-notes-multiselect-menu-container">
  <button mat-icon-button [matMenuTriggerFor]="menu" data-cy="tdo-notes-multiselect-menu-trigger">
    <mat-icon>keyboard_arrow_down</mat-icon>
  </button>

  <!-- Menu using Angular Material -->
  <mat-menu #menu="matMenu">
    <div *ngIf="type === 'category'" [style.max-height]="maxHeight + 'px'" class="menu-content" data-cy="tdo-notes-multiselect-menu-category-content">
      <!-- Select All Option -->
      <mat-checkbox *ngIf="isShowAllSelectors" (change)="onAllCategoriesClick($event)" data-cy="tdo-notes-multiselect-menu-select-all-categories">
        Select All
      </mat-checkbox>

      <!-- Category Items -->
      <mat-list data-cy="tdo-notes-multiselect-menu-category-list">
        <mat-list-item *ngFor="let item of selectableItems" data-cy="tdo-notes-multiselect-menu-category-item">
          <mat-checkbox [checked]="isCategorySelected(item)" (change)="onCategoryClicked(item)" data-cy="tdo-notes-multiselect-menu-category-checkbox">
            <!-- Checkbox only -->
          </mat-checkbox>
          <span data-cy="tdo-notes-multiselect-menu-category-label">{{ item.ItemDisplayValue }}</span> <!-- Text outside checkbox -->
        </mat-list-item>
      </mat-list>
    </div>

    <div *ngIf="type === 'type'" [style.max-height]="maxHeight + 'px'" class="menu-content" data-cy="tdo-notes-multiselect-menu-type-content">
      <!-- Select All Option for Types -->
      <mat-checkbox *ngIf="isShowAllSelectors" (change)="onAllTypesClick($event)" data-cy="tdo-notes-multiselect-menu-select-all-types">
        Select All
      </mat-checkbox>

      <!-- Type Items -->
      <mat-list data-cy="tdo-notes-multiselect-menu-type-list">
        <mat-list-item *ngFor="let item of selectableItems" data-cy="tdo-notes-multiselect-menu-type-item">
          <mat-checkbox [checked]="isTypeSelected(item)" (change)="onTypeClicked(item)" data-cy="tdo-notes-multiselect-menu-type-checkbox">
            <!-- Checkbox only -->
          </mat-checkbox>
          <span data-cy="tdo-notes-multiselect-menu-type-label">{{ item.ItemDisplayValue }}</span> <!-- Text outside checkbox -->
        </mat-list-item>
      </mat-list> 
    </div>
  </mat-menu>
</div>